module.exports = __webpack_public_path__ + "img/f4-3.d1f66e11.png";